import { useCallback } from 'react'

import Restrictions from 'app/common/components/Restrictions'
import ChangePassword from 'app/common/components/ChangePassword'
import selectIsChangePassword from 'app/common/components/ChangePassword/selectIsChangePassword'
import ChangeLogin from 'app/common/components/ChangeLogin'
import selectIsChangeLogin from 'app/common/components/ChangeLogin/selectIsChangeLogin'
import Confirmation from 'app/common/components/Confirmation'
import AnotherUserLoggedIn from 'app/common/components-next/another-user-logged-in'
import FailureHandler from 'app/common/components/FailureHandler'
import AppBar, { LeftBarContent, RightBarContent } from 'app/common/ui-components/app-bar'
import { appTypes } from 'app/common/api'
import Pages from 'app/pages'
import { useDetectOs } from 'app/common/hooks/useDetectOs'
import { useUser, useUserJivoCode } from 'app/dataProviders/user/hooks'
import { JivoWidget } from 'app/common/ui-components/jivo/JivoWidget'
import Person from 'app/common/classes/person'
import { Theme, getColorFromTheme } from 'app/common/components-next/color-theme'

import { /* RsnEmail, isRsnEmail, */ RsnDocument, isRsnDocument } from './restrictions'
import UserMenuLocal from './UserMenuLocal'
import enhanceApp from './enhanceApp'
import Logo from './Logo'
import AppFooter from './AppFooter'
import AppMenuItems from './AppMenuItems'
import FavoritesBar from './FavoritesBar'

import styles from './App.scss'

const loginRestrictions = {
  condition: selectIsChangeLogin,
  component: ChangeLogin,
}

const passwordRestrictions = {
  condition: selectIsChangePassword,
  component: ChangePassword,
}

const documentsRestrictions = {
  condition: isRsnDocument,
  component: RsnDocument,
}

type Props = {
  location: {
    pathname: string
  }
  history: {
    replace: (p: string) => void
  }
}

const App = ({ location, history: { replace } }: Props) => {
  const { pathname } = location

  const disabledDocumentsByCabinetType =
    (process.env.APP_NAME || process.env.REACT_APP_NAME) === appTypes.APP_TYPE_FOOD

  const restrictions = disabledDocumentsByCabinetType
    ? [loginRestrictions, passwordRestrictions]
    : [loginRestrictions, passwordRestrictions, documentsRestrictions]

  const { name, type, phone, email, loading: loadingUser } = useUser()

  const os = useDetectOs()
  const jivoCode = useUserJivoCode()

  const handleAnotherUser = useCallback(() => {
    replace('/')
  }, [replace])

  return (
    <div className={styles.root}>
      <JivoWidget
        jivoCode={jivoCode}
        name={new Person(name).getName().LastFirst || 'n/a'}
        phone={phone || 'n/a'}
        email={email || 'n/a'}
        role={{ parent: 'Родитель', student: 'Учащийся', employee: 'Сотрудник' }[type] || 'n/a'}
        os={os || 'n/a'}
        themeColor={getColorFromTheme(Theme.primaryColor)}
        ready={os !== 'Loading' && !!jivoCode && !loadingUser}
      />

      <AnotherUserLoggedIn onAnotherUser={handleAnotherUser} />
      <AppBar>
        <LeftBarContent>
          <Logo />
          <AppMenuItems
            pathname={pathname} // TODO внутрь
          />
        </LeftBarContent>
        <RightBarContent>
          <UserMenuLocal />
        </RightBarContent>
      </AppBar>
      <FavoritesBar />
      <div className={styles.body}>
        <Pages />
      </div>
      <AppFooter />
      <Confirmation />
      <Restrictions location={location} restrictions={restrictions} />
      <FailureHandler />
    </div>
  )
}

export default enhanceApp(App)
